import { render, staticRenderFns } from "./BusinessProgramMappingsSlideover.vue?vue&type=template&id=52e28f1a"
import script from "./BusinessProgramMappingsSlideover.vue?vue&type=script&lang=js"
export * from "./BusinessProgramMappingsSlideover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports